import { Box, Container, Stack, Typography, Link } from '@mui/material';

import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/iconify/iconify';

import { useResponsive } from 'src/hooks/use-responsive';
import { useNavigate } from 'react-router';

import Logo from 'src/components/logo/logo';

import { paths } from 'src/routes/paths';

export default function Footer() {
  const mdUp = useResponsive('up', 'md');
  const desktop = (
    <Box
      sx={{
        backgroundColor: '#2E428B',
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          pt: { xs: 10, md: 10 },
          pb: { xs: 5, md: 5 },
          pl: { xs: 5, md: 8 },
          pr: { xs: 8, md: 8 },
        }}
      >
        <Stack direction="row" justifyContent="space-between" spacing={2} alignItems="flex-start">
          <Address />
          <HomeMenu />
          <Component />
          <Coordination />
          <About />
          <Entity />
        </Stack>
        <PowerBy />
      </Container>
    </Box>
  );

  return <footer>{mdUp ? desktop : <Mobile />}</footer>;
}

const Mobile = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        backgroundColor: '#2E428B',
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          pt: { xs: 10, md: 10 },
          pb: { xs: 5, md: 5 },
          pl: { xs: 3, md: 8 },
          pr: { xs: 3, md: 8 },
        }}
      >
        <Stack direction="column" alignItems="center" spacing={2}>
          <Stack spacing={0.75} alignItems="center">
            <Typography
              variant="footer"
              sx={{ color: 'primary.main', fontWeight: '700 !important' }}
            >
              {t('footer.address')}
            </Typography>
            <Typography variant="footer" sx={{ color: 'common.white', fontWeight: '500' }}>
              {t('footer.address_content')}
            </Typography>
          </Stack>
          <Stack spacing={0.75} alignItems="center">
            <Typography
              variant="footer"
              sx={{ color: 'primary.main', fontWeight: '700 !important' }}
            >
              {t('footer.email')}
            </Typography>
            <Typography variant="footer" sx={{ color: 'common.white', fontWeight: '500' }}>
              snqcv.uc@gmail.com
            </Typography>
          </Stack>
          <Stack spacing={0.75} alignItems="center">
            <Typography
              variant="footer"
              sx={{ color: 'primary.main', fontWeight: '700 !important' }}
            >
              {t('footer.phone')}
            </Typography>
            <Typography variant="footer" sx={{ color: 'common.white', fontWeight: '500' }}>
              +238 333 7055/7076/7061
            </Typography>
          </Stack>
          <Stack spacing={0.75} alignItems="center">
            <Typography
              variant="footer"
              sx={{ color: 'primary.main', fontWeight: '700 !important' }}
            >
              {t('footer.followUs')}
            </Typography>
            <Stack spacing={0.75} direction="row">
              <Link href="https://www.facebook.com/ucsnq" target="_blank" rel="noopener">
                {' '}
                <Iconify
                  icon="ic:outline-facebook"
                  width={50}
                  sx={{ color: 'common.white' }}
                />{' '}
              </Link>
            </Stack>
          </Stack>
          <PowerBy />
        </Stack>
      </Container>
    </Box>
  );
};

const PowerBy = () => {
  const { t } = useTranslation();
  const mdUp = useResponsive('up', 'md');
  return (
    <Box
      sx={{
        width: '100%',

        justifyContent: 'center',
        display: 'flex',
        marginTop: { sm: '20px', md: '20px' },
      }}
    >
      <Stack spacing={0.75} alignItems="center">
        <Logo single={true} />
        <Typography
          variant="footer"
          sx={{
            color: 'common.white',
            fontWeight: '500',
            textTransform: 'capitalize',
            fontSize: { xs: '14px' },
          }}
        >
          {t('homePage.snq')}
        </Typography>
        {mdUp && (
          <Typography
            variant="footer"
            sx={{
              color: 'common.white',
              fontWeight: '500',
              textTransform: 'capitalize',
              fontSize: { xs: '14px' },
            }}
          >
            Powered by{' '}
            <Link href="#" rel="noopener" target="_blank" sx={{ color: 'common.white' }}>
              {' '}
              EG Soft Solutions{' '}
            </Link>
            , Copyright @ 2023
          </Typography>
        )}

        {!mdUp && (
          <>
            <Typography
              variant="footer"
              sx={{
                color: 'common.white',
                fontWeight: '500',
                textTransform: 'capitalize',
                fontSize: { xs: '14px' },
              }}
            >
              Powered by{' '}
              <Link href="#" rel="noopener" target="_blank" sx={{ color: 'common.white' }}>
                {' '}
                EG Soft Solutions{' '}
              </Link>
              , Copyright
            </Typography>
            <Typography
              variant="footer"
              sx={{
                color: 'common.white',
                fontWeight: '500',
                textTransform: 'capitalize',
                fontSize: { xs: '14px' },
              }}
            >
              @2023
            </Typography>
          </>
        )}
      </Stack>
    </Box>
  );
};

const Address = () => {
  const { t } = useTranslation();
  return (
    <Stack spacing={3} direction="row" justifyContent="space-around">
      <Stack spacing={2} justifyContent="flex-start">
        <Stack spacing={0.75}>
          <Typography variant="footer" sx={{ color: 'primary.main', fontWeight: '700 !important' }}>
            {t('footer.address')}
          </Typography>
          <Typography variant="footer" sx={{ color: 'common.white', fontWeight: '500' }}>
            {t('footer.address_content')}
          </Typography>
        </Stack>
        <Stack spacing={0.75}>
          <Typography variant="footer" sx={{ color: 'primary.main', fontWeight: '700 !important' }}>
            {t('footer.email')}
          </Typography>
          <Typography variant="footer" sx={{ color: 'common.white', fontWeight: '500' }}>
            snqcv.uc@gmail.com
          </Typography>
        </Stack>
        <Stack spacing={0.75}>
          <Typography variant="footer" sx={{ color: 'primary.main', fontWeight: '700 !important' }}>
            {t('footer.phone')}
          </Typography>
          <Typography variant="footer" sx={{ color: 'common.white', fontWeight: '500' }}>
            +238 333 7055/7076/7061
          </Typography>
        </Stack>
        <Stack spacing={0.75}>
          <Typography variant="footer" sx={{ color: 'primary.main', fontWeight: '700 !important' }}>
            {t('footer.followUs')}
          </Typography>
          <Stack spacing={0.75} direction="row">
            <Link href="https://www.facebook.com/ucsnq" target="_blank" rel="noopener">
              {' '}
              <Iconify icon="ic:outline-facebook" width={50} sx={{ color: 'common.white' }} />{' '}
            </Link>
          </Stack>
        </Stack>
      </Stack>
      <Box
        sx={{
          borderLeft: '2px solid #fff',
          borderRadius: '1px',
        }}
      />
    </Stack>
  );
};

const HomeMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Stack spacing={2} justifyContent="center" alignItems="flex-start">
      <Link
        component="button"
        onClick={() => {
          navigate(paths.root);
        }}
      >
        <Typography variant="footer" sx={{ color: 'primary.main', fontWeight: '700 !important' }}>
          {t('footer.home')}
        </Typography>
      </Link>
      <Link
        component="button"
        onClick={() => {
          navigate(paths.news);
        }}
      >
        <Typography variant="footer" sx={{ color: 'common.white', fontWeight: '700 !important' }}>
          {t('footer.news')}
        </Typography>
      </Link>
      <Link
        component="button"
        onClick={() => {
          navigate(paths.contact);
        }}
      >
        <Typography variant="footer" sx={{ color: 'common.white', fontWeight: '700 !important' }}>
          {t('footer.contact')}
        </Typography>
      </Link>
    </Stack>
  );
};

const Entity = () => {
  const { t } = useTranslation();
  return (
    <Stack spacing={2} justifyContent="flex-start">
      <Typography variant="footer" sx={{ color: 'primary.main', fontWeight: '700 !important' }}>
        {t('footer.entity')}
      </Typography>
      <Typography
        variant="footer"
        sx={{ color: 'common.white', fontWeight: '500', textTransform: 'capitalize' }}
      >
        {t('footer.accreditation')}
      </Typography>
      <Typography
        variant="footer"
        sx={{ color: 'common.white', fontWeight: '500', textTransform: 'capitalize' }}
      >
        {t('footer.approval')}
      </Typography>
    </Stack>
  );
};

const Coordination = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Stack spacing={2} justifyContent="flex-start" alignItems="flex-start">
      <Link
        underline="none"
        component="button"
        onClick={() => {
          navigate(paths.ucsnq);
        }}
      >
        <Typography variant="footer" sx={{ color: 'primary.main', fontWeight: '700 !important' }}>
          {t('footer.coordination')}
        </Typography>
      </Link>
      <Link
        underline="none"
        component="button"
        onClick={() => {
          navigate(paths.ucsnq);
        }}
      >
        <Typography
          variant="footer"
          sx={{ color: 'common.white', fontWeight: '500', textTransform: 'capitalize' }}
        >
          {t('footer.whatUCSNQ')}
        </Typography>
      </Link>
      <Link
        underline="none"
        component="button"
        onClick={() => {
          navigate(paths.ucsnq);
        }}
      >
        <Typography
          variant="footer"
          sx={{ color: 'common.white', fontWeight: '500', textTransform: 'capitalize' }}
        >
          {t('footer.howWork')}
        </Typography>
      </Link>
    </Stack>
  );
};

const About = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Stack spacing={2} justifyContent="flex-start" alignItems="flex-start">
      <Link
        underline="none"
        component="button"
        onClick={() => {
          navigate(paths.snq);
        }}
      >
        <Typography variant="footer" sx={{ color: 'primary.main', fontWeight: '700 !important' }}>
          {t('footer.about_us')}
        </Typography>
      </Link>

      <Link
        underline="none"
        component="button"
        onClick={() => {
          navigate(paths.snq);
        }}
      >
        <Typography
          variant="footer"
          sx={{ color: 'common.white', fontWeight: '500', textTransform: 'capitalize' }}
        >
          {t('footer.what_is')}
        </Typography>
      </Link>
      <Link
        underline="none"
        component="button"
        onClick={() => {
          navigate(paths.snq);
        }}
      >
        <Typography
          variant="footer"
          sx={{ color: 'common.white', fontWeight: '500', textTransform: 'capitalize' }}
        >
          {t('footer.principles')}
        </Typography>
      </Link>
    </Stack>
  );
};

const Component = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Stack spacing={2} justifyContent="flex-start" alignItems="flex-start">
      <Link
        component="button"
        underline="none"
        onClick={() => {
          navigate(paths.root);
        }}
      >
        <Typography variant="footer" sx={{ color: 'primary.main', fontWeight: '700 !important' }}>
          {t('footer.component')}
        </Typography>
      </Link>
      <Link
        underline="none"
        component="button"
        onClick={() => {
          navigate(paths.square);
        }}
      >
        <Typography
          variant="footer"
          sx={{ color: 'common.white', fontWeight: '500', textTransform: 'capitalize' }}
        >
          {t('homePage.square')}
        </Typography>
      </Link>
      <Link
        underline="none"
        component="button"
        onClick={() => {
          navigate(paths.catalog);
        }}
      >
        <Typography
          variant="footer"
          sx={{ color: 'common.white', fontWeight: '500', textTransform: 'capitalize' }}
        >
          {t('homePage.catalog')}
        </Typography>
      </Link>
      <Link
        underline="none"
        component="button"
        onClick={() => {
          navigate(paths.rvcc);
        }}
      >
        <Typography
          variant="footer"
          sx={{ color: 'common.white', fontWeight: '500', textTransform: 'capitalize' }}
        >
          {t('homePage.rvcc')}
        </Typography>
      </Link>
    </Stack>
  );
};
